var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("../types");
var operations_1 = require("../operations");
var PanesManager = /** @class */ (function (_super) {
    __extends(PanesManager, _super);
    function PanesManager(props) {
        var _this = _super.call(this, props) || this;
        _this.setCurrentPane = function (paneId) {
            _this.setState({
                panes: operations_1.setCurrentPane(_this.state.panes, paneId),
            });
        };
        _this.addContentToCurrentPane = function (content) {
            _this.setState({
                panes: operations_1.addContentToCurrentPane(_this.state.panes, content)
            });
        };
        _this.setPaneCurrentContent = function (paneId, contentId) {
            _this.setState({
                panes: operations_1.setPaneCurrentContent(_this.state.panes, paneId, contentId),
            });
        };
        _this.removePaneContent = function (paneId, contentId) {
            _this.setState({
                panes: operations_1.removePaneContent(_this.state.panes, paneId, contentId),
            });
        };
        _this.splitPane = function (paneId, axis) {
            _this.setState({
                panes: operations_1.splitPane(_this.state.panes, paneId, axis)
            });
        };
        _this.state = {
            panes: props.panes || [{
                    id: 'root',
                    isCurrent: true,
                    split: false,
                    splitAxis: types_1.PaneSplitAxis.Vertical,
                    contents: [],
                    children: [],
                }]
        };
        return _this;
    }
    PanesManager.prototype.render = function () {
        return this.props.render({
            panes: this.state.panes,
            contentTypes: this.props.contentTypes,
            setCurrentPane: this.setCurrentPane,
            addContentToCurrentPane: this.addContentToCurrentPane,
            setPaneCurrentContent: this.setPaneCurrentContent,
            removePaneContent: this.removePaneContent,
            splitPane: this.splitPane,
        });
    };
    return PanesManager;
}(React.Component));
exports.default = PanesManager;
